import React from 'react'

export const composeRefs = (
	...refs: (React.Ref<any> | null | undefined)[]
): React.Ref<any> => <T extends HTMLElement>(element: T) => {
	refs.forEach(ref => {
		if (ref) {
			if (typeof ref === 'function') {
				ref(element)
			} else {
				// @ts-ignore
				ref.current = element
			}
		}
	})
}
